import Vue from 'vue';

const state = {};

const mutations = {};

const actions = {
  async fetchOfficialsPg({dispatch}) {
    const {data, status} = await Vue.axios.get ('/pg_officials');
    if (status != 200) {
      await dispatch ('generateSnackBarMessage', {
        message: 'Ocurrió un error al obtener los funcionarios',
        type: 'error',
      });
    }
    return {data, status};
  },
  async updateOfficialsPg ({dispatch}, officialsPg) {
    const formData = new FormData ();
    formData.append ('title_cover_page', officialsPg.title_cover_page);
    if (officialsPg.file_cover_page) {
      formData.append ('file_cover_page', officialsPg.file_cover_page);
    }
    const {data, status} = await Vue.axios.post (
      `/pg_officials/${officialsPg.id}`,
      formData
    );
    if (status != 200 && status != 201 && status != 204) {
      await dispatch ('createResponseMessage', {
        message: data.message ||
          'Ocurrió un error actualizando los datos del funcionario',
        type: 'error',
      });
    } else {
      await dispatch ('generateSnackBarMessage', {
        message: data.message || 'Se guardó correctamente',
        type: 'success',
      });
    }
    return {data, status};
  },
};

export default {state, mutations, actions};
